var map = {
	"./nuckle_medium-webfont.woff": 3581,
	"./nuckle_medium-webfont.woff2": 7557,
	"./nuckle_regular-webfont.woff": 1058,
	"./nuckle_regular-webfont.woff2": 5940,
	"./nuckle_semi_bold-webfont.woff": 9986,
	"./nuckle_semi_bold-webfont.woff2": 4852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7025;